import { transformSpecializations } from '@/utils/profile';
import Section from '@/app/_components/widgets/profile/section';
import { AggregatorSpeciality } from '@/types-aggregatore';

type SpecializationsProps = {
  specializationsList: AggregatorSpeciality[];
};

const Specializations = ({ specializationsList }: SpecializationsProps) => (
  <Section title="specializzazioni" testId="profile specializations">
    <div className="grid grid-cols-2">
      {transformSpecializations(specializationsList).map((item, index) => (
        <h3 key={`${item.key}-${index}`} className="text-base font-medium text-inherit lg:text-lg">
          {item.value}
        </h3>
      ))}
    </div>
  </Section>
);

export default Specializations;
